import {Form} from '@deere/ux.uxframe-react'
import {getAnswerLabel,containsCheckBoxAnswer, getTranslation} from '../../utils/utils'

function containsAnswer(dateQuestion,answers){
    let answer = answers.find(a => a.questionId === parseInt(dateQuestion.id));
    return (answer && answer.answer.length > 1)
}


export default function DateOfpReviewSection({ofpSection,dateQuestion,answers}){



    function createCheckDate(selCheck){
        let answer = answers.find(a => a.questionId === parseInt(dateQuestion.id));
        if(!answer)//Valid if there is an answer for the check box option in redux object
            return <></>;

        //let checkedValues = answer.answer;
        //let isChecked = checkedValues && checkedValues.findIndex(lab => lab === selCheck.value) >= 0?true:false;
        if(!containsCheckBoxAnswer(selCheck.value,answer.answer)) // Valid if check box option is checked
            return <></>;
        
        let childDateQuestion = ofpSection.questions.find(q => q.type === 'DATE' && q.idQuestionDepends === dateQuestion.id 
                                                                && q.idSelectionDependson.toString() === selCheck.value );

        let dateResult = <><Form.Group className="pl-4 col-12">
                                <li>{getTranslation(selCheck, 'text')}</li>
                            </Form.Group>
                            <Form.Group className="pl-4 col-12">
                                <Form.Label className="uxf-label">{getTranslation(childDateQuestion, 'text')}</Form.Label>
                                <br/>
                                <Form.Label>{getAnswerLabel(childDateQuestion,answers)}</Form.Label>
                            </Form.Group></>;

        if(selCheck.value === '7'){//Case when 'Other' is checked, we have to render date an textarea
            let childTextQuestion = ofpSection.questions.find(q => q.type === 'OPEN_DATE' && q.idQuestionDepends === dateQuestion.id 
                                                                    && q.idSelectionDependson.toString() === selCheck.value );                                              
            return [dateResult,<Form.Group className="pl-4 col-12">
                            <Form.Label className="uxf-label">{getTranslation(childTextQuestion, 'text')}</Form.Label>
                            <br/>
                            <Form.Label>{getAnswerLabel(childTextQuestion,answers)}</Form.Label>
                        </Form.Group>
                    ]
        }
        return dateResult;//in other case, we just render date
        
    }

    return(containsAnswer(dateQuestion,answers)?
            <>
                <Form.Row className="d-block mb-4">
                    <Form.Group className="mb-4 pl-4">
                        <Form.Label className="uxf-label">{getTranslation(dateQuestion,'text')}</Form.Label>
                    </Form.Group>
                </Form.Row>
                <Form.Row className="d-block mb-4">
                    <div>
                            {
                                
                                dateQuestion.selections.sort((a, b) => (a.value > b.value) ? 1 : -1).map((sel,index) =>{
                                    return <div key={index}>                            
                                                {createCheckDate(sel)}
                                        </div> 
                            })
                            } 
                    </div>
                </Form.Row>
            </>:null
    )
}